export default {
  namespaced: true,

  state: {
    model: null,
    message: '',
    props: {
      top: true,
      bottom: false,
      right: true,
      left: false,
      color: 'red',
      timeout: 3000,
      'multi-line': true,
    },
  },

  mutations: {
    show(state, message) {
      state.message = message;
      state.model = true;
    },
    hide(state) {
      state.model = false;
    },
    props(state, props = {}) {
      state.props = { ...state.props, ...props };
    },
  },
};
